"use client"

import type { ReactNode } from "react"
import { Badge } from "@/components/ui/badge"
import { BotOff } from "lucide-react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"
import { useTranslations } from "next-intl"


export const AI_REPLY_OFF_TOOLTIP =
  "AI Reply is switched off on the AI Reply tab — no AI replies on any channel. Channels whose own AI replies switch is off still send their Offline message."

/**
 * The explanation on any trigger. A portalled tooltip, not `title`: the text is two sentences and
 * the native one runs off the window edge on a right-aligned control.
 */
export function AiReplyOffHint({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs">{AI_REPLY_OFF_TOOLTIP}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

/** Shown wherever an agent looks answerable but is not: headers, the card, the inbox. */
export function AiReplyOffBadge({ className }: { className?: string }) {
  const tUi = useTranslations("Messaging.AgentsMessagingAiReplyOffBadge")

  return (
    <AiReplyOffHint>
      <Badge
        variant="outline"
        tabIndex={0}
        className={cn("gap-1 border-amber-300 font-normal text-amber-700", className)}
      >
        <BotOff className="h-3 w-3" />
        <span><span key={tUi("aIReplyOff")}>{tUi("aIReplyOff")}</span></span>
      </Badge>
    </AiReplyOffHint>
  )
}
